export const fr = {
  // ==================== PERSONAL INFO ====================
  personal: {
    firstName: "Panagiotis",
    lastName: "Bekos",
    fullName: "Panagiotis Bekos",
    profession: "Sculpteur sur bois",
    bio: `Mon approche de cette tradition est fondée sur l’étude et l’apprentissage auprès des grands maîtres sculpteurs sur bois,
    dont les créations révèlent savoir, expérience, sensibilité et un haut niveau d’artisanat. Souvent, leur travail reflète
    l’expérience ecclésiastique vivante capturée dans la matière inanimée, autant que possible.`,
  },

  // ==================== CONTACT INFO ====================
  contact: {
    email: "p9bekos@gmail.com",
    phone: "+30 6936881488",
    address: {
      street: "Aristotelous 23",
      city: "Helioupoli",
      postalCode: "16343",
      country: "Grèce",
    },
    social: {
      facebook: "https://www.facebook.com/your-page",
      instagram: "https://www.instagram.com/your-account",
    },
  },

  // ==================== HEADER ====================
  header: {
    woodcarverName: "Panagiotis",
    woodcarverSurname: "Bekos",
    woodcarverSpeciality: "Sculpteur sur bois",
    main: "Accueil",
    gallery: "Créations",
    about: "Atelier",
    contact: "Contact"
  },

  // ==================== FOOTER ====================
  footer: {
    woodcarverFullName: "Panagiotis Bekos",
    description: "Sculpteur sur bois",
    main: "Accueil",
    gallery: "Créations",
    about: "Atelier",
    contact: "Contact"
  },

  // ==================== MAIN PAGE ====================
  main: {
    heroTitle: "Sculpture sur bois",
    heroSubtitle: "L’art qui grave des histoires au cœur du bois",
    gallerySubtitle: "CATÉGORIES",
    galleryTitle: "Créations",
    textToGallery: "Découvrez toutes mes créations",
    buttonToGallery: "Voir la collection",
    contactSubtitle: "CONTACT",
    contactTitle: "Contactez-moi",
    footerImageText: "\"…et que la beauté du Seigneur notre Dieu soit sur nous, et affermis l’ouvrage de nos mains ; oui, affermis l’ouvrage de nos mains.\" - Psaume 89:17"
  },

  // ==================== GALLERY PAGE ====================
  gallery: {
    heroTitle: "Art de la sculpture sur bois",
    heroSubtitle: "Œuvres sculptées avec passion et amour pour la tradition",
    title: "Créations",
    subtitle: "CATÉGORIES",
    category: "CATÉGORIE",
    footerImageText: "\"Quoi que vous fassiez, faites-le de bon cœur, comme pour le Seigneur et non pour les hommes\" - Colossiens 3:23",
    return: "← Retour aux catégories",
    notAvailable: "Cette catégorie n’est pas encore disponible",
  },

  // ==================== ABOUT PAGE ====================
  about: {
    heroTitle: "Atelier de sculpture sur bois",
    heroSubtitle: "L’endroit où l’art de sculpter le bois prend vie",
    title: "Notre Atelier",
    subtitle: "HISTOIRE",
    aboutMeTitle: "À propos de moi",  // eslint-disable-next-line
    aboutMeText: "Mon approche de cette tradition repose sur l’étude et l’apprentissage fondés sur les œuvres de grands sculpteurs sur bois, \
                qui révèlent savoir, expérience, sensibilité, haute technique, et qui sont souvent l’empreinte de l’expérience ecclésiastique \
                sur une matière inanimée, autant que possible.",
    woodcarverFullName: "Panagiotis Bekos",
    woodcarverSpeciality: "Sculpteur sur bois",
    footerImageText: "\"Car nous sommes son ouvrage, créés en Jésus-Christ pour de bonnes œuvres\" - Éphésiens 2:10"
  },

  // ==================== CONTACT PAGE ====================
  contactPage: {
    heroTitle: "Contact",
    heroSubtitle: "Contactez-moi pour plus d’informations",
    title: "Contactez-moi",
    subtitle: "CONTACT",
    contactInfoTitle: "Coordonnées",
    phoneTitle: "TÉLÉPHONE",
    addressTitle: "ADRESSE",
    followMe: "SUIVEZ-MOI",
    quickMessageTitle: "Message rapide",
    quickMessageText: "Envoyez-moi un court message et je vous contacterai bientôt",
    nameTitle: "Nom",
    namePlaceholder: "Votre nom",
    messageTitle: "Message",
    messagePlaceholder: "Écrivez votre message...",
    messageButton: "Envoyer le message",
    messageSending: "Envoi...",
    messageSent: "Envoyé !",
    messageSuccess: "Merci ! Je vous contacterai bientôt.",
    footerImageText: "\"…regarde tes serviteurs et tes œuvres, et guide leurs enfants\" - Psaume 89:16"
  },

  // ==================== CATEGORIES ====================
  categories: {
    main: "Accueil",
    gallery: "Créations",
    about: "Atelier",
    contact: "Contact",
    agies_trapezes: "Saints Autels",
    amvones: "Ambons",
    analogia: "Lutrins", // Also known as Analogion
    artoforia: "Artophore",
    despotikoi_thronoi: "Trônes épiscopaux",
    diafora: "Divers",
    diskelia: "Tabourets Pliants",
    epipla: "Meubles",
    epitafioi: "Cénotaphes",
    filoptoha: "Boîtes de bienfaisance",
    kornizes: "Cadres",
    lipsanothikes: "Reliquaires",
    kirothikes: "Boîtes d’offrandes",
    polithrones: "Fauteuils",
    portes: "Portes",
    proskinitaria: "Supports d’icônes",
    prothikes: "Vitrines",
    stasidia_karekles: "Stalles de chœur - Chaises",
    stavroi: "Croix",
    stefanothikes: "Boîtes à Couronnes",
    templa: "Iconostases",
    trapezia: "Tables",
    vimothira: "Portes d'autel",
  },

  categoriesNoTones: {
    main: "Accueil",
    gallery: "Créations",
    about: "Atelier",
    contact: "Contact",
    agies_trapezes: "Saints Autels",
    amvones: "Ambons",
    analogia: "Lutrins", // Also known as Analogion
    artoforia: "Artophore",
    despotikoi_thronoi: "Trônes épiscopaux",
    diafora: "Divers",
    diskelia: "Tabourets Pliants",
    epipla: "Meubles",
    epitafioi: "Cénotaphes",
    filoptoha: "Boîtes de bienfaisance",
    kornizes: "Cadres",
    lipsanothikes: "Reliquaires",
    kirothikes: "Boîtes d’offrandes",
    polithrones: "Fauteuils",
    portes: "Portes",
    proskinitaria: "Supports d’icônes",
    prothikes: "Vitrines",
    stasidia_karekles: "Stalles de chœur - Chaises",
    stavroi: "Croix",
    stefanothikes: "Boîtes à Couronnes",
    templa: "Iconostases",
    trapezia: "Tables",
    vimothira: "Portes d'autel",
  },

  // ==================== MESSAGES ====================
  messages: {
    emailCopied: "Email copié !",
    phoneCopied: "Numéro de téléphone copié !",
    nameRequired: "Le nom est requis.",
    emailRequired: "L’email est requis.",
    nameInvalid: "Le nom contient des caractères non valides.",
    emailInvalid: "Email invalide.",
    messageRequired: "Le message est requis.",
    sendFailed: "L’envoi a échoué. Veuillez réessayer.",
  }
};
